import { COLORS } from "../../../../utils/colors"

export const useResultsModalStyles = () => {
    return {
      calendarContainer: {
        overflowY: 'auto',
        maxHeight: '90vh',
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        width: '100%',
        backgroundColor: COLORS.WHITE,
        paddingTop: '0px',
        
      },
      title: {
        fontSize: '1.25rem',
        marginRight: '1rem',
        margin: '1.375rem 1.813rem'
      },
      header: {
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: '#fff',
        alignItems: 'center',
        width: '100%',
      },
      tableHeader: {
        backgroundColor: '#f3f6f9',
      },
      chip: {
        marginRight: '1rem'
      },
      resetButton: {
        fontSize: '12px', 
        textDecoration: 'underline',
        color: '#dc0808',
        cursor: 'pointer'
      }
    }
}